var React = require('react');

var ALikeStore = require("../store/ALikeStore");

var {ProductTableContainer, Cell,CellTitle, CellContent } = require('./ProductTableContainer');

/**
 * 产品的特殊说明的表格
 */
var ProductTipsTable = ({title,tips})=>
    <div className="price-profile-iml">
        <h3 className="title mod-title">
            <span className="main c-orange">{ title }</span>
        </h3>
        <div className="mod-product-table">
            <div className="bd-padding">
                <ProductTableContainer>
                    <Cell>
                        <CellTitle>
                            <i className="icon-product-tip-8"/>
                            <h4>火车</h4>
                        </CellTitle>
                        <CellContent>
                            {tips}
                        </CellContent>
                    </Cell>
                </ProductTableContainer>
            </div>
        </div>
    </div>


/**
 * 特殊的商品提示，目前暂时只有日本这个特殊需求
 */
var ExtraProductTips = React.createClass({

    render: function () {
        var tips = ALikeStore.get_productTips();
        var title = '日本火车提示'
        return (
            tips ? <ProductTipsTable title={ title } tips={ tips.train }  />
                : null
        );
    }

});

module.exports = ExtraProductTips;




/** WEBPACK FOOTER **
 ** ./script/detail/ExtraProductTips.jsx
 **/